import { Button } from "@/components/ui/button";
import { WifiOff, Lock, ShieldAlert, ServerCrash, RefreshCw } from "lucide-react";

/** Classe une erreur axios en état lisible : réseau / session / interdit / serveur. */
export function classifyError(e) {
  const st = e?.response?.status;
  const detail = e?.response?.data?.detail;
  const msg = typeof detail === "string" ? detail : detail?.message || detail?.msg;
  if (!e?.response) return { kind: "network", title: "Réseau temporairement indisponible", text: "Vérifiez votre connexion puis réessayez.", retry: true };
  if (st === 401) return { kind: "session", title: /désactivé|terminé/i.test(msg || "") ? "Accès désactivé" : "Session expirée", text: msg || "Reconnectez-vous pour continuer.", login: true };
  if (st === 403 || st === 423) return { kind: "forbidden", title: "Accès interdit", text: msg || "Vous n'avez pas accès à cet élément." };
  if (st === 404) return { kind: "missing", title: "Élément introuvable", text: msg || "Cet élément n'existe plus ou n'est pas accessible." };
  if (st === 429) return { kind: "rate", title: "Trop de tentatives", text: "Patientez une minute puis réessayez.", retry: true };
  const ref = e?.response?.data?.error_ref;
  return { kind: "server", title: "Erreur serveur", text: "Une erreur technique est survenue. Réessayez dans un instant.", retry: true, ref };
}

const ICONS = { network: WifiOff, session: Lock, forbidden: ShieldAlert, missing: ShieldAlert, rate: RefreshCw, server: ServerCrash };

export function EmpError({ error, onRetry, onLogin, compact }) {
  const s = classifyError(error);
  const I = ICONS[s.kind] || ServerCrash;
  return <div className={`rounded-2xl border border-slate-200 bg-white ${compact ? "p-3" : "p-5"} text-center`} data-testid={`emp-error-${s.kind}`} role="alert">
    <I className="w-6 h-6 mx-auto text-slate-400" /><div className="font-semibold text-sm mt-2" data-testid="emp-error-title">{s.title}</div><p className="text-xs text-slate-500 mt-1">{s.text}</p>
    {s.ref && <p className="text-[11px] text-slate-400 mt-1" data-testid="emp-error-ref">Référence support : {s.ref}</p>}
    <div className="flex justify-center gap-2 mt-3">
      {s.retry && onRetry && <Button size="sm" onClick={onRetry} className="h-11 rounded-xl px-4" data-testid="emp-error-retry"><RefreshCw className="w-4 h-4 mr-1" /> Réessayer</Button>}
      {s.login && <Button size="sm" onClick={onLogin || (() => { window.location.assign("/salarie/connexion?next=" + encodeURIComponent(window.location.pathname + window.location.search)); })} className="h-11 rounded-xl px-4" data-testid="emp-error-login">Se reconnecter</Button>}
    </div>
  </div>;
}

export function EmpLoading({ label = "Chargement…" }) {
  return <p className="text-sm text-slate-400 p-4 flex items-center gap-2" data-testid="emp-loading"><RefreshCw className="w-4 h-4 animate-spin" /> {label}</p>;
}
